import * as styles from './ErrorDisplay.module.less';
import { ErrorInfo } from "@/common/twshared/errorHandling/ErrorInfo";
import { parseError } from "@/common/twshared/errorHandling/errorParser";
import { useEffect, useState } from "react";

export interface IErrorDisplayProps {
    error: any;
    title?: string;
}

export const ErrorDisplay = ({error, title}: IErrorDisplayProps) => {
    const [info, setInfo] = useState<ErrorInfo>();

    useEffect(() => {
        setInfo(error ? parseError(error) : undefined);
    }, [error]);

    if (!info) {
        return;
    }

    return (
        <div>
            {
                title && <div className={styles.title}>{title}</div>
            }
            {
                info.messages.map((x, i) => (
                    <div key={i} className={styles.message}>{x.text}</div>
                ))
            }
        </div>
    );
};